import { useI18n } from '@/hooks/useI18n.ts';
import { useUserStore } from '@/store/modules/user/store.js';
import ConversationDisplayUser from '@/entities/ConversationDisplayUser.ts';

export function useConversationDisplayUserResolver() {
    const userStore = useUserStore();
    const { t } = useI18n();

    function resolveUsers(userIds: number[]): ConversationDisplayUser[] {
        return userIds.map((id) => {
            const user = userStore.getUserById(id);

            if (!user) {
                return ConversationDisplayUser.createPlaceholder(id, t('general.unknown'));
            }

            return ConversationDisplayUser.fromStoreUser(user);
        });
    }

    return { resolveUsers };
}
